<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}, made with by TVC News
            <a
              href="https://www.tvcnews.co"
              class="font-weight-bold"
              target="_blank"
              >Creative Tim</a
            >
            for a better web.
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a
                href="https://www.tvcnews.co"
                class="nav-link text-muted"
                target="_blank"
                >TVC NEWS</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://www.inv.tvcnews.co/aboutus"
                class="nav-link text-muted"
                target="_blank"
                >About Us</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
